export default __webpack_public_path__ + "static/media/masterplan.56352ea4.webp";